import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../teamschat-summary.action';
import {
    defaultState,
    TeamschatSummaryState,
} from '../teamschat-summary.state';
import { chatSummaryTransformer } from '../transformer/chat-summary.transformer';

import { Load, LoadResult } from './load.action';

export function loadReducer(
    state: TeamschatSummaryState,
    action: PayloadAction<ActionType, Load>,
): TeamschatSummaryState {
    const nextState = defaultState();
    nextState.hasPendingData = true;

    return nextState;
}

export function loadResultReducer(
    state: TeamschatSummaryState,
    action: PayloadAction<ActionType, LoadResult>,
): TeamschatSummaryState {
    const chatSummary = chatSummaryTransformer(action.payload.chatCategories);

    return {
        ...state,
        chatCategories: action.payload.chatCategories ?? [],
        chatSummary,
        filteredChatSummary: chatSummary,
        hasPendingData: false,
    };
}
